<div class="container mt-4">
  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>
  <app-register-stepper [progressData]="getProgressData()" [user]="_user"></app-register-stepper>

  <div class="row mb-5 account-detail-container">
    <div class="col-12">
      <div class="row mb-3">
        <div class="col-12">
          <h1 class="text-center">
            Your details
          </h1>
        </div>
      </div>

      <form
       #ownerDetailForm="ngForm"
       (ngSubmit)="updateOwnerDetailsAndAddresses()"
       novalidate>

        <div class="row">
          <div class="owner-detail-address-section">
            <div class="mb-3">
              <label class="form-label" for="title">
                Title
              </label>
              <select
                #title="ngModel"
                class="form-control form-select"
                [class.is-invalid]="title.touched && title.invalid"
                id="title"
                name="title"
                [(ngModel)]="keeperDetailModel.title">
                <option [ngValue]="null" disabled>Please choose an option</option>
                <option *ngFor="let titleEntry of UserTitles" [ngValue]="titleEntry">
                  {{ titleEntry }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label" for="firstName">
                Name*
              </label>
              <input
                #firstName="ngModel"
                class="form-control"
                [class.is-invalid]="firstName.touched && !firstName.valid"
                id="firstName"
                name="firstName"
                [(ngModel)]="keeperDetailModel.firstName"
                placeholder="Your first name"
                (blur)="keeperDetailModel.firstName = keeperDetailModel.firstName.trim()"
                required
                type="text"/>
              <div
                *ngIf="firstName.errors && firstName.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="lastName">
                Last name*
              </label>
              <input
                #lastName="ngModel"
                class="form-control"
                [class.is-invalid]="lastName.touched && !lastName.valid"
                id="lastName"
                name="lastName"
                [(ngModel)]="keeperDetailModel.lastName"
                placeholder="Your last name"
                (blur)="keeperDetailModel.lastName = keeperDetailModel.lastName.trim()"
                required
                type="text"/>
              <div
                *ngIf="lastName.errors && lastName.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="dateOfBirth">
                Date of birth
              </label>
              <div class="input-group">
                <input
                  #dateOfBirth="ngbDatepicker"
                  #dateOfBirthModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="dateOfBirthModel.touched && dateOfBirthModel.invalid"
                  name="dateOfBirth"
                  [(ngModel)]="dateOfBirthValue"
                  placeholder="dd/mm/yyyy"
                  [startDate]="{year: 1990, month: 12}"
                  ngbDatepicker
                  [maxDate]="today"
                  [minDate]="minDate">
                  <button
                    class="btn btn-outline-secondary calendar"
                    (click)="dateOfBirth.toggle()"
                    type="button">
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors && 
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.invalid"
                  class="invalid-feedback">
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors &&
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.maxDate"
                  class="invalid-feedback">
                  Please enter a date not later than today.
                </div>
                <div
                  *ngIf="dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors &&
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.minDate"
                  class="invalid-feedback">
                  Please enter a date after
                  {{ dateOfBirthModel.errors.ngbDate.minDate.minDate.day + '/' +
                    dateOfBirthModel.errors.ngbDate.minDate.minDate.month + '/' +
                    dateOfBirthModel.errors.ngbDate.minDate.minDate.year }}.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="gender">
                Gender
              </label>
              <select
              #gender="ngModel"
              class="form-control form-select"
              [class.is-invalid]="gender.touched && gender.invalid"
              id="gender"
              name="gender"
              [(ngModel)]="keeperDetailModel.gender">
                <option [ngValue]="null" disabled>Please choose an option</option>
                <option *ngFor="let genderEntry of Genders" [ngValue]="genderEntry">
                  {{ genderEntry }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label" for="phoneNumber">
                Phone number*
              </label>
              <input
                #phoneNumber="ngModel"
                class="form-control"
                [class.is-invalid]="phoneNumber.touched && !phoneNumber.valid"
                id="phoneNumber"
                name="phoneNumber"
                [(ngModel)]="keeperDetailModel.mainPhoneNumber"
                placeholder="Your phone number"
                (blur)="keeperDetailModel.mainPhoneNumber = keeperDetailModel.mainPhoneNumber.trim()"
                [pattern]="validationPatterns.telephone"
                required
                type="text"/>
              <div
                *ngIf="phoneNumber.errors && phoneNumber.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
              *ngIf="phoneNumber.errors && phoneNumber.errors.pattern && !phoneNumber.errors.minlength"
              class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="secondPhoneNumber">
                Second phone number
              </label>
              <input
                #secondPhoneNumber="ngModel"
                class="form-control"
                [class.is-invalid]="secondPhoneNumber.touched && !secondPhoneNumber.valid"
                id="secondPhoneNumber"
                name="secondPhoneNumber"
                [(ngModel)]="keeperDetailModel.secondPhoneNumber"
                placeholder="Your second phone number"
                (blur)="keeperDetailModel.secondPhoneNumber = keeperDetailModel.secondPhoneNumber.trim()"
                [pattern]="validationPatterns.telephone"
                type="text"/>
              <div
              *ngIf="secondPhoneNumber.errors && secondPhoneNumber.errors.pattern && !secondPhoneNumber.errors.minlength"
              class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>
          </div>

          <div class="owner-detail-address-section">
            <div class="mb-4 postcode-check-wrapper">
              <label class="form-label" for="postcodeCheck">
                <strong>Start typing your postcode</strong>
              </label>
              <input
                class="form-control"
                id="postcodeCheck"
                name="postcodeCheck"
                [(ngModel)]="postcodeCheck"
                placeholder="Your postcode"
                (input)="onPostCodeCheckChanges($event)"
                (keydown.enter)="focusOnSelect()"
                type="text"
              />

                <div *ngIf="isPostcodeInvalid" class="postcode-invalid">
                  The provided postcode is invalid!
                </div>

                <div *ngIf="addressesSelectList.length > 0" class="mb-3">
                  <label class="form-label" for="title">
                    Select your address
                  </label>
                  <select
                   class="form-control form-select"
                   id="selectedAddress"
                   name="selectedAddress"
                   [(ngModel)]="selectedAddress"
                   (ngModelChange)="onSelectAddressChanged($event)">
                    <option [ngValue]="null" disabled>Select address...</option>
                    <option *ngFor="let addressOption of addressesSelectList" [ngValue]="addressOption">
                      {{ getAddressLabel(addressOption) }}
                    </option>
                  </select>
                </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="addressLine1">
                Address line 1*
              </label>
              <input
                #addressLine1="ngModel"
                class="form-control"
                [class.is-invalid]="addressLine1.touched && !addressLine1.valid"
                id="addressLine1"
                name="addressLine1"
                [(ngModel)]="addressModel.addressLine1"
                placeholder="Address line 1"
                (blur)="addressModel.addressLine1 = addressModel.addressLine1.trim()"
                required
                type="text"/>
              <div
                *ngIf="addressLine1.errors && addressLine1.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="addressLine2">
                Address line 2
              </label>
              <input
                #addressLine2="ngModel"
                class="form-control"
                [class.is-invalid]="addressLine2.touched && !addressLine2.valid"
                id="addressLine2"
                name="addressLine2"
                [(ngModel)]="addressModel.addressLine2"
                placeholder="Address line 2"
                (blur)="addressModel.addressLine2 = addressModel.addressLine2.trim()"
                type="text"/>
            </div>

            <div class="mb-3">
              <label class="form-label" for="townPerCity">
                Town/City*
              </label>
              <input
                #townPerCity="ngModel"
                class="form-control"
                [class.is-invalid]="townPerCity.touched && !townPerCity.valid"
                id="townPerCity"
                name="townPerCity"
                [(ngModel)]="addressModel.townPerCity"
                placeholder="Town/City"
                required
                type="text">
              <div
                *ngIf="townPerCity.invalid && townPerCity.errors && townPerCity.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="postcode">
                Postcode*
              </label>
              <input
                #postcode="ngModel"
                class="form-control"
                [class.is-invalid]="(postcode.touched && !postcode.valid)"
                id="postcode"
                name="postcode"
                [(ngModel)]="addressModel.postcode"
                placeholder="Postcode"
                required
                type="text">
              <div
                *ngIf="postcode.errors && postcode.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>
          </div>
        </div>

        <div class="explanation-wrapper">
          <span class="sign">* </span>
          <span class="description">Required field</span>
        </div>

        <button
         type="submit"
         class="btn d-block btn-success text-white btn-lg w-100 mt-2 update-details-button"
         [disabled]="!ownerDetailForm.valid || loading">
          <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
          Update details
        </button>
        <button
        *ngIf="canSkip"
        type="button"
        class="btn d-block btn-secondary text-white btn-lg w-100 mt-2 update-details-button"
        (click)="onNextClick()"
        [disabled]="!ownerDetailForm.valid || loading || !canSkip">
         <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
         Next
       </button>
      </form>
    </div>
  </div>

</div>
